module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tag', {
    class: 'label_' + _vm.statusKey,
    attrs: {
      "type": "default"
    }
  }, [_vm._v(_vm._s(_vm.statusName))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ecb7826c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/paper/PaperStatusLabel.vue
// module id = 791
// module chunks = 2